/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Select, message, Spin } from "antd";
import API from "../../api";
import urls from "../../api/urls";
//import "./style.scss";
const { GET_ALL_RATE_SLABS } = urls;
import { masterSlabAPI } from "../../api/RateCardApi";
const SlabSelect = ({
  head,
  value,
  onChange,
  //setRateSlabList1,
  createSlab,
  predefined,
  disable,
  slabFetch,
}) => {
  const { Option } = Select;
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const fetchSlabs = async () => {
    try {
      setLoading(true);
      // let url = GET_ALL_RATE_SLABS;
      // if (predefined) {
      //   url = `${GET_ALL_RATE_SLABS}?chargesHead=${head}&searchTerm=${search}&page=${currentPage}`;
      // } else {
      //   url = `${GET_ALL_RATE_SLABS}?searchTerm=${search}&page=${currentPage}`;
      // }
      // const response = await API.Api(url).get();
      let params = {
        page: 1,
        limit: 50,
      };

      if (searchValue) {
        params.searchTerm = searchValue;
      }

      let response = await masterSlabAPI.getAllSlabList(params);
      if (response?.status) {
        const data = response?.response?.data?.items;

        let dataSlab =
          data?.map((item) => ({
            label: item?.name,
            value: item.rateCardId,
            ...item,
          })) || [];
        setOptions(dataSlab);
        //setRateSlabList1(dataSlab);

        //setHasMore(response?.response?.data?.total > 10 || false);
      } else {
        message.error(
          response?.response?.data?.message ||
            `Error fetching slabs for ${head} slabs`
        );
      }
    } catch (error) {
      console.error(`Error fetching slabs for ${head}:`, error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSlabs();
  }, [value, slabFetch, searchValue]);

  const handleSearch = (value) => {
    setSearchValue(value);
    setPage(1);
  };

  const handleScroll = (event) => {
    const { target } = event;
    if (
      target.scrollTop + target.offsetHeight === target.scrollHeight &&
      hasMore &&
      !loading
    ) {
      setPage((prev) => prev + 1);
    }
  };

  return (
    <div className="d-flex" key={head}>
      <Select
        showSearch
        allowClear
        placeholder="Choose Slab"
        style={{ width: "300px" }}
        value={value}
        onSearch={handleSearch}
        onPopupScroll={handleScroll}
        notFoundContent={loading ? <Spin size="small" /> : "No options"}
        filterOption={false}
        onChange={onChange}
        disabled={disable}
      >
        {options.map((item) => (
          <Option key={item.value} value={item.value}>
            {item.label}
          </Option>
        ))}
      </Select>
      {value && (
        <>
          <a
            className="align-center ml-1"
            onClick={() => {
              createSlab(value, options, head);
            }}
          >
            View Slab
          </a>
        </>
      )}
    </div>
  );
};
export default SlabSelect;
